import { Link } from "react-router-dom";
import { AppConstant } from "../../../Shared/Utils/AppConstant";
import { ChangePasswordForm } from "./ChangePasswordForm";

export const ChangePassword = () => {
  return (
    <>
      <div className="container">
        <section className="flex flex-col md:flex-row h-screen items-center">
          <div className="hidden md:block bg-white w-full md:max-w-md lg:max-w-full md:mx-auto md:mx-0 md:w-1/2 xl:w-2/3 h-screen px-6 lg:px-16 xl:px-12">
            <div className="mt-6 w-full h-100 py-5 flex items-center justify-center">
              <div className="">
                <div className="py-5 my-4">&nbsp;</div>

                <div className="py-3 text-2xl font-semibold">
                  <h1 className="">
                    Welcome to <br /> {AppConstant.CompanyName}
                  </h1>
                </div>
                <div className="py-5">
                  <p>
                    Let’s get you all set up so you can verify your <br />{" "}
                    personal account and begin setting up your profile
                  </p>
                </div>
                <div className="py-5">
                  <div className="">
                    <div>
                      If you have already an account you can <br /> you can
                      <span className="px-3">
                        <Link
                          to="/auth/login"
                          className="text-sky-600 font-medium	"
                        >
                          Sign in here
                        </Link>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-indigo w-full md:max-w-md lg:max-w-full md:mx-auto md:w-1/2 xl:w-1/2 h-screen px-6 lg:px-16 xl:px-12">
            <div className="w-full h-100">
              <ChangePasswordForm />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
